import React from 'react';
import StackManager from '../components/supplements/StackManager';
import SupplementQuiz from '../components/supplements/SupplementQuiz';

// The Supplements hub. Discover (the honesty-first goal quiz, SS4) → manage (your
// standing stack, SS1). The quiz drives the same deterministic, safety-gated SS3
// engine; profile-tied suggestions also live on /you. Anonymous visitors get the
// same quiz at the public /quiz route.

const SupplementsPage = () => {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 pt-2 pb-10">
      <SupplementQuiz
        heading="Not sure where to start?"
        subheading="Answer a couple of questions and get honest, evidence-graded suggestions — including when food does the job or you can skip it."
        showSignupCta={false}
      />
      <div className="mt-8">
        <StackManager />
      </div>
    </div>
  );
};

export default SupplementsPage;
